function checkManualEntryForm() {
    const manualForm = document.querySelector('.ak-content-section .manual-entry-form');

    if (manualForm) {
        console.log("Manual entry form detected");

        // Your JS logic here
        const od_sphSelect = manualForm.querySelector('#od_sph');
        if (od_sphSelect && od_sphSelect.value == "") {
            od_sphSelect.value = "0.00"; // new value
            od_sphSelect.dispatchEvent(new Event('change')); // trigger change if needed
        }
        const od_cylSelect = manualForm.querySelector('#od_cyl');
        if (od_cylSelect && od_cylSelect.value == "") {
            od_cylSelect.value = "0.00"; // new value
            od_cylSelect.dispatchEvent(new Event('change')); // trigger change if needed
        }
        const od_axisSelect = manualForm.querySelector('#od_axis');
        if (od_axisSelect && od_axisSelect.value == "") {
            od_axisSelect.value = "0"; // new value
            od_axisSelect.dispatchEvent(new Event('change')); // trigger change if needed
        }
        const os_sphSelect = manualForm.querySelector('#os_sph');
        if (os_sphSelect && os_sphSelect.value == "") {
            os_sphSelect.value = "0.00"; // new value
            os_sphSelect.dispatchEvent(new Event('change')); // trigger change if needed
        }
        const os_cylSelect = manualForm.querySelector('#os_cyl');
        if (os_cylSelect && os_cylSelect.value == "") {
            os_cylSelect.value = "0.00"; // new value
            os_cylSelect.dispatchEvent(new Event('change')); // trigger change if needed
        }
        const os_axisSelect = manualForm.querySelector('#os_axis');
        if (os_axisSelect && os_axisSelect.value == "") {
            os_axisSelect.value = "0"; // new value
            os_axisSelect.dispatchEvent(new Event('change')); // trigger change if needed
        }
    }
}

// Run once
checkManualEntryForm();

// Observe DOM changes
const observer = new MutationObserver(function() {
    checkManualEntryForm();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});